import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  forgetSuccessMsg: null,
  forgetError: null,
  resetPasswordSuccessMsg: null,
  resetPasswordError: null,
  resetPasswordLoading: false,
  loading: false,
};

const forgotPasswordSlice = createSlice({
  name: "forgotpwd",
  initialState,
  reducers: {
      userForgetPassword(state) {
        state.loading = true;
        state.forgetError = null;
        state.forgetSuccessMsg = null;
      },
      userForgetPasswordSuccess(state, action) {
          state.forgetSuccessMsg = action.payload;
          state.loading = false;
      },
      userForgetPasswordError(state, action) {
          state.forgetError = action.payload;
          state.loading = false;
      },
      userPerformResetPassword(state) {
        state.resetPasswordLoading = true;
        state.resetPasswordError = null;
        state.resetPasswordSuccessMsg = null;
      },
      userPerformResetPasswordSuccess(state, action) {
        state.resetPasswordSuccessMsg = action.payload;
        state.resetPasswordLoading = false;
      },
      userPerformResetPasswordError(state, action) {
        state.resetPasswordError = action.payload;
        state.resetPasswordLoading = false;
      },
      clearErrorMessage(state) { 
        state.forgetSuccessMsg = null;
        state.forgetError = null;
        state.loading = false;
        state.resetPasswordSuccessMsg = null; 
        state.resetPasswordError = null;
        state.resetPasswordLoading = false;
      },
  },
}); 

export const {
  userForgetPassword,
  userForgetPasswordSuccess,
  userForgetPasswordError,
  clearErrorMessage,
} = forgotPasswordSlice.actions
export const {
  userPerformResetPassword, userPerformResetPasswordSuccess, userPerformResetPasswordError
} = forgotPasswordSlice.actions;

export default forgotPasswordSlice.reducer;
